export default {
  pageTitle(state) {
    let last = state.breadcrumbs[state.breadcrumbs.length - 1];
    if (last && last.title) {
      return last.title;
    }
  },
};
